module.exports = __webpack_public_path__ + "static/media/not-completed.fc0c42d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/donuts/not-completed.svg
// module id = 1706
// module chunks = 0